import {post} from "../utils";

export default host => (contentCreatorId) =>
  post(`${host}/contentCreators/${contentCreatorId}/duplicate`)
    .then(response => response.json())
    .then(json => json.data);